import { rem } from 'polished';
import Icon from '../../Icon';
import styled from 'styled-components';
export const Chevron = styled(Icon) `
  margin-left: ${rem(12)};
`;
export const Label = styled.div `
  color: ${({ theme }) => theme.textColor};
  font-weight: 500;
  font-size: ${rem(14)};
  text-align: initial;
`;
export const SubLabel = styled.div `
  margin-top: ${rem(2)};
  font-size: ${rem(12)};
  font-weight: normal;
  color: ${({ theme }) => theme.color.fadedText};
`;
